module.exports = __webpack_public_path__ + "static/media/bdm-icons.7cc9ed2b.eot";